import styled, { keyframes } from "styled-components";
import { NavLink } from "react-router-dom";
import { ReactComponent as LogoGift } from "../../../assets/icons/gift-empty.svg";
import { ReactComponent as Arrow } from "../../../assets/icons/arrow.svg";
import { ReactComponent as Logout } from "../../../assets/icons/logout2.svg";
import { ReactComponent as LeftArrow } from "../../../assets/icons/chevron-left.svg";
import { ReactComponent as Search } from "../../../assets/icons/search2.svg";

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;

export const SidebarContainer = styled.div`
  position: fixed;
  margin-top: ${(props) => (props.$height ? "0px" : "126px")};
  display: flex;
  background: white;
  box-shadow: 0px 0px 10px 5px rgba(0, 0, 0, 0.05);
  flex-direction: column;
  min-width: ${(props) => (props.$opened ? "26rem" : "2.5rem")};
  max-width: ${(props) => (props.$opened ? "26rem" : "2.5rem")};
  z-index: 10;
  user-select: none;
  top: 0;
  bottom: 0;

  left: ${(props) => (props.$ar ? "unset" : 0)};
  right: ${(props) => (!props.$ar ? 0 : "unset")};
  transition: all 0.3s ease-in-out;

  @media (max-width: 870px) {
    display: none;
  }
`;

export const LogoGiftIcon = styled(LogoGift)`
  height: auto;
  @media (max-height: 985px) {
    width: 40px;
  }
`;

export const LogoutIcon = styled(Logout)`
  height: auto;
  width: 24px;
  @media (max-height: 985px) {
    width: 21px;
  }
`;
export const ArrowIcon = styled(Arrow)`
  height: auto;
  transform: ${(props) => (props.$ar ? "rotate(180deg)" : "none")};
  @media (max-height: 985px) {
    width: 8px;
    path {
      stroke-width: 1.35px;
    }
  }
`;
export const ChevronContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  position: absolute;
  height: 3rem;
  width: 3rem;
  border-radius: 50%;
  cursor: pointer;
  background-color: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(5px);
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.25);
  -webkit-backdrop-filter: blur(5px);
  bottom: 5rem;
  z-index: 2000000;
  right: ${(props) => (!props.$ar ? "-1.5rem" : "unset")};
  left: ${(props) => (props.$ar ? "-1.5rem" : "unset")};
  transform: ${(props) => (props.$ar ? "scaleX(-1)" : "unset")};
`;

export const NavContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  width: 100%;
  gap: 1rem;

  /*
  @media (max-height: 825px) {
     max-height: ${(props) =>
    props.$categoriesBar ? "calc(62dvh - 46px)" : "62dvh"};
    }
    */
  /* @media (max-height: 695px) {
    max-height: ${(props) =>
    props.$categoriesBar ? "calc(50dvh - 46px)" : "50dvh"};
  }
  @media (max-height: 640px) {
    max-height: ${(props) =>
    props.$categoriesBar ? "calc(45dvh - 46px)" : "45dvh"};
  }
  @media (max-height: 565px) {
    max-height: ${(props) =>
    props.$categoriesBar ? "calc(40dvh - 46px)" : "40dvh"};
  }
  @media (max-height: 515px) {
    max-height: ${(props) =>
    props.$categoriesBar ? "calc(30dvh - 46px)" : "30dvh"};
  }
  @media (max-height: 448px) {
    max-height: ${(props) =>
    props.$categoriesBar ? "calc(20dvh - 46px)" : "20dvh"};
  } */
`;
export const ChevronRight = styled(LeftArrow)`
  rotate: 180deg;
`;
export const ChevronLeft = styled(LeftArrow)``;
export const NavDiv = styled.div`
  width: 100%;
  display: flex;
  gap: 5rem;
  flex-direction: column;

  @media (max-height: 985px) {
    gap: 25px;
  }
`;

export const IconContainer = styled.div`
  width: 35px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-height: 985px) {
    width: 25px;
    height: 25px;
  }
`;

export const LogoText = styled.span`
  font-family: "Avenir-Light";
  font-style: normal;
  font-size: 20px;
  line-height: 27px;
  letter-spacing: -0.177777px;
  margin-left: -12px;
  color: #484888;
`;

export const Relative = styled.div`
  position: relative;
  background-color: red;

  @media (max-height: 1200px) {
    display: none;
  }
`;
export const LogoContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  @media (max-height: 1200px) {
    display: none;
  }
`;

export const Animation = styled.div`
  animation: ${(props) => (props.$open ? fadeIn : fadeOut)} 0.2s ease-in-out;
`;
export const AdminInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-bottom: 100px;
  @media (max-height: 1130px) {
    margin-bottom: 50px;
  }
  @media (max-height: 985px) {
    margin-bottom: 25px;
  }
`;

export const PhotoElipse = styled.div`
  width: 101px;
  height: 101px;
  display: none;
  border-radius: 50%;
`;

export const AdminName = styled.span`
  font-family: "Avenir-Heavy";
  font-style: normal;
  font-size: 20px;
  line-height: 24px;
  text-align: center;
  letter-spacing: -0.266666px;
  text-transform: uppercase;
  color: #222239;
  max-width: 20rem;
  white-space: pre-wrap;
  word-wrap: break-word;
  @media (max-width: 870px) {
    max-width: none;
  }
  @media (max-height: 985px) {
    font-size: 18px;
  }
`;

export const AdminAccount = styled.span`
  user-select: none;
  font-family: "Avenir-Light";
  font-style: normal;

  font-size: 16px;

  letter-spacing: -0.177777px;

  color: #484888;

  opacity: 0.6;
  @media (max-height: 985px) {
    font-size: 14px;
  }
`;

export const Row = styled.div`
  cursor: pointer;
  width: fit-content;
  align-items: center;
  gap: 15px;
  display: flex;
  flex-direction: row;
`;
export const NavTitle = styled.span`
  font-family: "Avenir-Medium", sans-serif;
  font-weight: 400;
  user-select: none;
  font-size: 18px;
  letter-spacing: -0.18px;
  color: #fff;
`;
export const ProfilePhoto = styled.img`
  min-width: 101px;

  max-width: 170px;
  max-height: 101px;
  margin-bottom: 1rem;
  border-radius: 50%;

  @media (max-height: 1200px) {
    max-height: 80px;
    min-width: auto;
  }
`;
export const ProfilePicEmpty = styled.div`
  width: 101px;
  height: 101px;
  border-radius: 50%;
  background: white;
  display: flex;
  align-items: center;
  border: 1px solid #484888;
  justify-content: center;
  margin-bottom: 1rem;
  @media (max-height: 985px) {
    width: 80px;
    height: 80px;
  }
`;

export const StyledBar = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  flex-direction: column;
  align-items: center;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: #fff;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #c8c8db;
    border-radius: 10px;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 7.5rem;
  width: 100%;

  @media (max-height: 985px) {
    margin-top: 4rem;
    margin-bottom: 18px;
  }
`;

export const GiftContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  color: #000;
  font-family: "Avenir";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0.067px;
`;

export const UpgradeButton = styled.button`
  border-radius: 5px;
  cursor: pointer;
  background: #484888;
  height: 41px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 12px;
  padding-right: 12px;
  color: #fff;
  font-family: "Avenir";
  gap: 20px;
  white-space: nowrap;
  font-size: 14px;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
  letter-spacing: 0.067px;
  border: none;
  @media (max-width: 825px) {
    font-size: 13px;
  }
`;

export const LogoutButton = styled(GiftContainer)`
  color: #c66b66;
  transition: all 0.2s ease-in-out;
  padding-left: 10px;
`;

export const StyledNavLink = styled(NavLink)`
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  opacity: 0.6;
  text-decoration: none;
  color: ${(props) => (props.$logout ? "#c66b66" : "#484888")};
  font-family: "Avenir-Medium";
  gap: 1rem;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.0666667px;
  transition: all 0.2s ease-in-out;
  padding: 1rem 2rem;
  width: 100%;
  /* border-radius: 3rem; */
  white-space: nowrap;

  border-bottom: 1px solid #f4efee;

  &.active {
    opacity: 1;
    /* background-color: #48488830; */
  }

  &:hover {
    opacity: 1;
  }
`;

export const PackageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  cursor: pointer;
  color: #000;
  font-family: "Avenir";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0.067px;
`;

export const TestText = styled.span`
  color: #484888;
  font-size: 1.1rem;
  text-align: center;
  position: absolute;
  bottom: 3.5px;
  right: ${(props) => (props.$ar ? "unset" : "-13.5px")};
  left: ${(props) => (!props.$ar ? "unset" : "-13.5px")};
`;

export const FiltersContainer = styled.div`
  background-color: white;
  display: flex;
  position: sticky;
  flex-direction: column;
  z-index: 10000;
  width: fit-content;

  position: sticky;
  top: ${(p) => (p.$open ? "calc(140px + 4rem)" : "2rem")}; // ispod headera
  align-self: flex-start;
  width: 280px;
  background: white;
  z-index: 10;
  @media (max-width: 870px) {
    display: none;
  }
`;
export const FilterWrapper = styled.div`
  gap: 1rem;
  display: flex;
  flex-direction: column;
`;
export const FilterSearch = styled.input`
  outline: none;
  width: 100%;
  border: none;
  padding-right: 2rem;
  border-bottom: 1px solid black;
  color: #484888;
  font-size: 1.4rem;
  font-family: "Avenir-Medium";
`;
export const Filter = styled.div`
  display: flex;
  flex-direction: row;
  cursor: pointer;
  align-items: center;
  gap: 1rem;
`;
export const FilterLabel = styled.span`
  color: #475569;
  user-select: none;
  font-size: 1.4rem;
  font-family: "Avenir-Medium";
  font-weight: 300;
  white-space: nowrap;
`;
export const FilterRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
`;
export const FilterTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const FilterTitle = styled.span`
  font-size: 2rem;
  font-family: "Avenir-Heavy";
  font-weight: 600;
  color: #0f172a;
`;
export const FilterSubtitle = styled.span`
  color: #64748b;
  font-family: "Avenir-Heavy";
  font-size: 14px;
  font-weight: 600;
  line-height: 20px; /* 142.857% */
`;

export const SearchIcon = styled(Search)`
  position: absolute;
  cursor: ${(props) => (props.$active ? "pointer" : "default")};
  right: 0rem;
  width: 18px;
  height: 18px;
  top: 50%;
  transform: translateY(-50%);
  path {
    fill: ${(props) => (props.$active ? "#484888" : "#5F6368")};
    fill-opacity: ${(props) => (props.$active ? 1 : 0.25)};
  }
`;

export const FilterSearchContainer = styled.div`
  position: relative;
`;
